import delegate from 'delegate'

/**
 * For cards/griditems where the whole element
 * should be clickable, but we just use the anchor
 * tag in the header, for accessibility
 */

export default function () {
  delegate('[data-sublink]', 'click', e => {
    const a = e.delegateTarget.querySelector('a')
    if (a && e.target !== a) {
      a.click()
      return
    }
    const btn = e.delegateTarget.querySelector('button')
    if (btn && e.target !== btn) {
      btn.click()
      return
    }
  }, false)
}